// extracted by mini-css-extract-plugin
module.exports = {"RowContainer":"ColorRow_RowContainer__2t4eK","Color":"ColorRow_Color__2V0vo"};